// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3u16U","sendOtp":"AuthorizeToLogin_sendOtp__GXqek"};